import React, { useCallback, useContext } from 'react';
import * as Icons from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { DnsTableContext } from '../context';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { v1 as uuid } from 'uuid';
import { CustomsService } from '../services';
import { tableFilterQueryMaker } from '@modules/refunds/utils';
import { AppHeaderPortal } from '@modules/layout/components/header-portal';
import { StyledActionBar } from '@shared/styled/action-bar';
import { StyledHeaderButton } from '@modules/layout/styled/header';

export const DnsActions = () => {
  const { t } = useTranslation();
  const { handleFetch, handleReset, state: { filters } } = useContext(DnsTableContext);

  const onExcelExport = useCallback(async () => {
    message.loading({ key: 1, content: "Loading" })
    const response = await CustomsService.Dns.excelExport(tableFilterQueryMaker(filters));
    if (response.status === 200) {
      message.success({ key: 1, content: "Success", duration: 2 })
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectURL;
      a.download = `customs_${uuid()}.xls`;
      a.click();
    } else {
      message.error({ key: 1, content: response.data.toString() })
    }
  }, [filters])

  return (
    <AppHeaderPortal>
      <StyledActionBar $flex={true}>
        <div>
          <StyledHeaderButton $ghost={true} onClick={handleFetch} icon={<Icons.ReloadOutlined />}>
            {t('common.actions.reload')}
          </StyledHeaderButton>
          <StyledHeaderButton $ghost={true} onClick={handleReset} icon={<Icons.ClearOutlined />}>
            {t('common.actions.reset')}
          </StyledHeaderButton>
        </div>
        <div>
          <StyledHeaderButton onClick={onExcelExport} $ghost={true} icon={<Icons.ExceptionOutlined />}>
            Excel export
          </StyledHeaderButton>
          <NavLink to='/customs/dns/acceptance'>
            <StyledHeaderButton $ghost={true} icon={<Icons.BarcodeOutlined />}>
              {t('dns.autoAcceptance.short')}
            </StyledHeaderButton>
          </NavLink>
        </div>
      </StyledActionBar>
    </AppHeaderPortal>
  );
};
